// AWS WAF CAPTCHA integration settings.
//
// The API key is a PUBLIC client-side integration key. AWS designs it to be
// embedded in page source, so it is not a credential and committing it leaks
// nothing. It lives here — in one module — because the previous integration
// duplicated it across wafenv.json, util.js and a comment in ContactUs.js, and
// they drifted.
//
// Both values can be overridden at build time (Create React App inlines any
// REACT_APP_* variable), which is what you want if the WebACL is ever recreated:
//   REACT_APP_WAF_JSAPI_URL, REACT_APP_WAF_CAPTCHA_API_KEY
//
// Source of truth is the `retnet-beta-ACL` WebACL in account 637423312503,
// us-east-1. Regenerate both if that ACL is replaced.

const DEFAULT_JSAPI_URL =
  'https://2e54b70402ca.us-east-1.captcha-sdk.awswaf.com/2e54b70402ca/jsapi.js';

const DEFAULT_API_KEY =
  'iGQtV7OqCW7NjuVaF3MwOOR3KX9445BFA6LS/I2Z7JUnBCYr8sO1Zzb17w1GVktu9087t6S5JUFy+wH/fZaQwAoPcQwhNUTjiPcPB0ZxBEKkAbsSQeafuqgI5odnlA6N9a1oC4vt/ofYocB/zyT8tqSVGik+IEmmQrRmC/uf8U5vGDUeZ3gSQHqLVE8Ggz6xxydB9L15K6+NSmXdbfGdl6PVbqjI/ectTJkL4DkrtuQ0ZrA8tGslQV/Zn8520v3XhaI/Ry0ORirQGT0XxO3mXr1MTy2gpPXnvE89hhap2itiPM8rjGv2FWo5hmQSEXS1QJjvGrrIvygDu+eKeokSxYjyYV2dwu8TGb6cP0dUIXn5Qgn0xSogOQWLtJttlAKXnmhifg8SmYqX7q8pj3Bnsdla9qE1L8M5lXXsjjRRyJEnHEku0GG84V7G9PpCsvTCvlIOTm6YYgR9QG8R6wY6WGlabB8NPZZi8Jnq79/PoHK33SCzYG2j0Wekcyd4bZj6EMZyHojzTwkBnazB2W6zsI6CCs9KtKS3kGCZuoPgcHqwUOvlMmZEiRMbb8byMk4eXDzXw/kwOj9L2QxgdKWQOmd7pfaT6WxDnZ9x6bYN/TNjx4j3uZ82OoDb8fjo01EIoB4au4DwEZfbbKN1/wrjjQJv6DQN73Z78njZCqFIeoA=_0_1';

export const WAF_JSAPI_URL =
  process.env.REACT_APP_WAF_JSAPI_URL || DEFAULT_JSAPI_URL;

export const WAF_CAPTCHA_API_KEY =
  process.env.REACT_APP_WAF_CAPTCHA_API_KEY || DEFAULT_API_KEY;

// DOM ids for the challenge modal. Namespaced so they cannot collide with the
// app's own Modal component.
export const OVERLAY_ID = 'wafCaptchaOverlay';
export const MODAL_ID = 'wafCaptchaModal';
export const FORM_ID = 'wafCaptchaForm';
